import clsx from "clsx";
import { StyledFormControlError } from "./atoms.styles";

/**
 * FormFieldError
 * Displays an error message for form fields like input, select, or radio buttons.
 *
 * @param {string} message - The error message to be displayed.
 */
export const FormFieldError = ({ message, className = "" }) =>
  message && (
    <div className={clsx("fv-plugins-message-container", className)}>
      <div className="fv-help-block">
        <span role="alert">{message}</span>
      </div>
    </div>
  );

export const FormControlError = ({ errorMsg, ...props }) => {
  return <StyledFormControlError {...props}>{errorMsg}</StyledFormControlError>;
};
